import React, { useEffect, useState } from "react";

function App() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Docker/K8s (QA y producción): Nginx hace proxy de /api/ hacia el
    // backend dentro del mismo contenedor/clúster, sin CORS ni hostnames
    // hardcodeados.
    //
    // Cloudflare Pages: es hosting estático puro, no puede correr un proxy
    // — el build de Cloudflare define REACT_APP_API_URL apuntando directo
    // a la URL pública del backend de QA. El backend ya acepta CORS desde
    // cualquier origen (ver server.js) para soportar este caso.
    const backendUrl = process.env.REACT_APP_API_URL || "/api/";

    fetch(backendUrl)
      .then((res) => res.json())
      .then((json) => setData(json))
      .catch((err) => setError(err.message));
  }, []);

  return (
    <div style={{ fontFamily: "sans-serif", textAlign: "center", marginTop: "4rem" }}>
      <h1>Examen DevOps — Grupo Promass</h1>
      {error && <p style={{ color: "red" }}>Error conectando al backend: {error}</p>}
      {data && (
        <div>
          <p>{data.message}</p>
          <p>Entorno: <strong>{data.entorno}</strong></p>
        </div>
      )}
      {!data && !error && <p>Conectando al backend...</p>}
    </div>
  );
}

export default App;